// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Ql51","container":"styles_container__2iBje","title":"styles_title__3OUDX","wrapper":"styles_wrapper__2ce7m","answer":"styles_answer__2eJj1"};